export const INITIALIZE = 'com.Handy.language.INITIALIZE';
export const SET_REQUESTING = 'com.Handy.language.SET_REQUESTING';
export const SET_LANGUAGE_TEXTS = 'com.Handy.language.SET_LANGUAGE_TEXTS';
export const CLEAR = 'com.Handy.language.CLEAR';
